import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomePage } from '@practium/features/home';
import { useAuth } from '@practium/features/auth';
import { useForBinding } from '@practium/features/forBinding';
import { useGetPlanSummary } from '@practium/features/api';
import { UserRole } from '@practium/shared';
import { consumePaymentCelebrationPending, fireSuccessConfetti } from '../../../shared/utils/paymentCelebration';
import {
	farmerHomeMockData,
	consultantHomeMockData,
	companyHomeMockData,
} from '../services';

export const HomePageClient = () => {
	const navigate = useNavigate();
	const { user } = useAuth();
	const { isForBinding, forBindingUser } = useForBinding();
	const { data: summary } = useGetPlanSummary(!isForBinding);

	useEffect(() => {
		if (consumePaymentCelebrationPending()) {
			fireSuccessConfetti();
		}
	}, []);

	const getHomeData = () => {
		const role = isForBinding ? forBindingUser?.role : user?.role;

		switch (role) {
			case UserRole.Farmer:
				return farmerHomeMockData;
			case UserRole.Consultant:
				return consultantHomeMockData;
			case UserRole.Company:
				return companyHomeMockData;
			default:
				return farmerHomeMockData;
		}
	};

	const homeData = getHomeData();
	const currentUser = isForBinding ? forBindingUser : user;
	const liveUser = {
		...homeData.user,
		name: currentUser?.name ?? homeData.user.name,
	};
	const livePlanInfo = {
		name: summary?.plan?.name ?? homeData.planInfo.name,
		expirationDate: summary?.expiresIn
			? new Date(summary.expiresIn).toLocaleDateString('pt-BR')
			: homeData.planInfo.expirationDate,
		upgradeMessage:
			summary?.canUpgrade && summary?.upgradePlanName
				? `Aproveite mais recursos com o plano ${summary.upgradePlanName}.`
				: homeData.planInfo.upgradeMessage,
	};

	const handleNavigation = (link: string) => {
		navigate(link);
	};

	return <HomePage data={{ ...homeData, user: liveUser, planInfo: livePlanInfo }} onNavigate={handleNavigation} />;
};
